// extracted by mini-css-extract-plugin
var _1 = "EntityProfileHeaderStaticAvatar-moduleEntityProfileHeaderStaticAvatar__neeE2";
export { _1 as "EntityProfileHeaderStaticAvatar" }
